import { useAuth } from 'react-oidc-context';
import { useMemo } from 'react';
import { FeedbackService } from '../services/FeedbackService';
import { FeedbackData } from '../models/FeedbackData';
import { RootState } from '../../redux/app/store';
import { useSelector } from 'react-redux';

export const useFeedback = () => {
    const auth = useAuth();
    const token = auth.user?.access_token;
    const hostContext = useSelector((state: RootState) => state.hostContext.hostContext);

    const feedbackService = useMemo(() => new FeedbackService(token ?? ''), [token]);

    const postFeedback = async (data: FeedbackData) => {
        try {
            await feedbackService.postFeedbackAsync(data, hostContext);
            return { success: true };
        } catch (error) {
            console.error('Error posting feedback:', error);
            throw error;
        }
    };

    return {
        postFeedback,
    };
};
